import React from 'react';
import { Link } from 'react-router-dom';

const SignatureComplete: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-3">Signature Complete!</h2>
        <p className="text-gray-600 mb-6">
          Thank you for signing your insurance proposal. Your agent has been notified and will be in touch shortly.
        </p>
        <p className="text-sm text-gray-500">
          You may now close this window.
        </p>
      </div>
    </div>
  );
};

export default SignatureComplete;